var map = {
	"./crypto/ADA.svg": 76773,
	"./crypto/AKT.svg": 57933,
	"./crypto/ALGO.svg": 7806,
	"./crypto/APT.svg": 69036,
	"./crypto/ARB.svg": 77692,
	"./crypto/ATOM.svg": 81836,
	"./crypto/AVAX.svg": 26033,
	"./crypto/AXL.svg": 43660,
	"./crypto/BASE.svg": 93068,
	"./crypto/BCH.svg": 30670,
	"./crypto/BLAST.svg": 62391,
	"./crypto/BNB.svg": 6191,
	"./crypto/BSC.svg": 25973,
	"./crypto/BSV.svg": 62808,
	"./crypto/BTC.svg": 9980,
	"./crypto/CELO.svg": 99936,
	"./crypto/CKB.svg": 72861,
	"./crypto/CORE.svg": 3158,
	"./crypto/CSPR.svg": 44071,
	"./crypto/DAG.svg": 15861,
	"./crypto/DAI.svg": 30307,
	"./crypto/DAO.svg": 26301,
	"./crypto/DASH.svg": 65427,
	"./crypto/DESO.svg": 53272,
	"./crypto/DGB.svg": 17306,
	"./crypto/DOGE.svg": 32624,
	"./crypto/DOT.svg": 40300,
	"./crypto/EGLD.svg": 72083,
	"./crypto/ENJ.svg": 39460,
	"./crypto/EOS.svg": 30138,
	"./crypto/ETC.svg": 56907,
	"./crypto/ETH.svg": 7936,
	"./crypto/EVER.svg": 16179,
	"./crypto/FIL.svg": 89176,
	"./crypto/FLOW.svg": 96699,
	"./crypto/FLR.svg": 75398,
	"./crypto/FTM.svg": 16198,
	"./crypto/HBAR.svg": 9316,
	"./crypto/ICP.svg": 27425,
	"./crypto/ICX.svg": 53689,
	"./crypto/KAI.svg": 46508,
	"./crypto/KAS.svg": 42678,
	"./crypto/KAVA.svg": 12256,
	"./crypto/KDA.svg": 18135,
	"./crypto/KLAY.svg": 36964,
	"./crypto/KSA.svg": 30366,
	"./crypto/KSM.svg": 81514,
	"./crypto/LTC.svg": 84490,
	"./crypto/MATIC.svg": 36779,
	"./crypto/MINA.svg": 92522,
	"./crypto/NBL.svg": 51825,
	"./crypto/NEAR.svg": 61190,
	"./crypto/OP.svg": 9290,
	"./crypto/OSMO.svg": 7941,
	"./crypto/POL.svg": 93848,
	"./crypto/RON.svg": 37332,
	"./crypto/ROSE.svg": 18462,
	"./crypto/RUNE.svg": 80715,
	"./crypto/SEI.svg": 86848,
	"./crypto/SOL.svg": 68527,
	"./crypto/STX.svg": 23830,
	"./crypto/SUI.svg": 65616,
	"./crypto/TIA.svg": 63171,
	"./crypto/TON.svg": 65222,
	"./crypto/USDC.svg": 30760,
	"./crypto/USDT.svg": 25271,
	"./crypto/VARA.svg": 33419,
	"./crypto/VET.svg": 78092,
	"./crypto/XLM.svg": 264,
	"./crypto/XRP.svg": 955,
	"./crypto/XTZ.svg": 96319,
	"./crypto/ZEC.svg": 20759,
	"./crypto/ZEN.svg": 42210,
	"./crypto/ZKSYNC_MAINNET.svg": 47198,
	"./fiat/AED.svg": 4032,
	"./fiat/ALL.svg": 27651,
	"./fiat/AMD.svg": 27640,
	"./fiat/ANG.svg": 76450,
	"./fiat/ARS.svg": 49874,
	"./fiat/AUD.svg": 90256,
	"./fiat/AZN.svg": 11839,
	"./fiat/BAM.svg": 26438,
	"./fiat/BBD.svg": 44338,
	"./fiat/BDT.svg": 73624,
	"./fiat/BGN.svg": 23035,
	"./fiat/BHD.svg": 61188,
	"./fiat/BMD.svg": 9331,
	"./fiat/BND.svg": 37014,
	"./fiat/BOB.svg": 78295,
	"./fiat/BRL.svg": 6010,
	"./fiat/BWP.svg": 62973,
	"./fiat/CAD.svg": 23266,
	"./fiat/CHF.svg": 12207,
	"./fiat/CLP.svg": 21541,
	"./fiat/CNY.svg": 53446,
	"./fiat/COP.svg": 39484,
	"./fiat/CRC.svg": 37408,
	"./fiat/CZK.svg": 99088,
	"./fiat/DJF.svg": 31318,
	"./fiat/DKK.svg": 97344,
	"./fiat/DOP.svg": 58623,
	"./fiat/EGP.svg": 61646,
	"./fiat/EUR.svg": 76818,
	"./fiat/GBP.svg": 56287,
	"./fiat/GEL.svg": 9458,
	"./fiat/GHS.svg": 30270,
	"./fiat/GTQ.svg": 79952,
	"./fiat/HKD.svg": 58747,
	"./fiat/HRK.svg": 4935,
	"./fiat/HUF.svg": 88287,
	"./fiat/IDQ.svg": 69478,
	"./fiat/IDR.svg": 5701,
	"./fiat/ILS.svg": 49708,
	"./fiat/INR.svg": 11671,
	"./fiat/IQD.svg": 4316,
	"./fiat/ISK.svg": 33461,
	"./fiat/JMD.svg": 7483,
	"./fiat/JOD.svg": 83665,
	"./fiat/JPY.svg": 80737,
	"./fiat/KES.svg": 40041,
	"./fiat/KGS.svg": 92799,
	"./fiat/KHR.svg": 1211,
	"./fiat/KRW.svg": 436,
	"./fiat/KWD.svg": 21696,
	"./fiat/KYD.svg": 27042,
	"./fiat/KZT.svg": 1420,
	"./fiat/LKR.svg": 78017,
	"./fiat/MAD.svg": 94144,
	"./fiat/MDL.svg": 40127,
	"./fiat/MGA.svg": 68679,
	"./fiat/MKD.svg": 89406,
	"./fiat/MNT.svg": 8069,
	"./fiat/MOP.svg": 64446,
	"./fiat/MUR.svg": 52618,
	"./fiat/MXN.svg": 2449,
	"./fiat/MYR.svg": 20006,
	"./fiat/MZN.svg": 63323,
	"./fiat/NAD.svg": 33227,
	"./fiat/NGN.svg": 37151,
	"./fiat/NOK.svg": 82106,
	"./fiat/NPR.svg": 5494,
	"./fiat/NZD.svg": 24422,
	"./fiat/OMR.svg": 80772,
	"./fiat/PAB.svg": 17919,
	"./fiat/PEN.svg": 23471,
	"./fiat/PGK.svg": 66952,
	"./fiat/PHP.svg": 90410,
	"./fiat/PKR.svg": 66381,
	"./fiat/PLN.svg": 3664,
	"./fiat/PYG.svg": 18394,
	"./fiat/QAR.svg": 73258,
	"./fiat/RON.svg": 69507,
	"./fiat/RSD.svg": 79045,
	"./fiat/RUB.svg": 94085,
	"./fiat/SAR.svg": 73036,
	"./fiat/SEK.svg": 78569,
	"./fiat/SGD.svg": 89736,
	"./fiat/SOS.svg": 72575,
	"./fiat/THB.svg": 55524,
	"./fiat/TRY.svg": 83033,
	"./fiat/TWD.svg": 93723,
	"./fiat/TZS.svg": 99723,
	"./fiat/UAH.svg": 64812,
	"./fiat/UGX.svg": 77558,
	"./fiat/USD.svg": 97934,
	"./fiat/UYU.svg": 41937,
	"./fiat/UZS.svg": 4918,
	"./fiat/VND.svg": 12706,
	"./fiat/XAF.svg": 41227,
	"./fiat/XOF.svg": 32621,
	"./fiat/XPF.svg": 55204,
	"./fiat/YER.svg": 71334,
	"./fiat/ZAR.svg": 36777,
	"./fiat/ZMW.svg": 4808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97666;